import { Component, OnInit } from '@angular/core';
import { TasacionesService } from '../../../services/tasaciones.service';

@Component({
  selector: 'app-ps-stats',
  templateUrl: './ps-stats.component.html',
  styleUrls: ['./ps-stats.component.scss']
})
export class PsStatsComponent implements OnInit {

  datasource: any;
  dataLoaded = false;

  constructor(private _tasacionesService: TasacionesService) { }

  ngOnInit() {
    this._tasacionesService.getPsStatsData().subscribe((data: any) => {
      this.datasource = data;
      this.dataLoaded = true;
    })
  }

}
